import React from "react";

export const MobileZip = ({ zip }) => {
  return (
    <div className="irq-nav-wrapper">
      <div className="mobile-stat-wrapper">
        <span className="bold">{zip}</span>
      </div>
      Zip Code
    </div>
  );
};
